module.exports = __webpack_public_path__ + "static/media/logo-app.1c22ef24.png";